export default __webpack_public_path__ + "static/media/ourP5.3b2dc0a8.png";